import { Component } from '@angular/core';
import { CourseApplicationService } from '../../../../services/courseApplication/course-application.service';
import { NotificationService } from '../../../../services/notification/notification.service';
import { SharedService } from '../../../../services/shared/shared.service';
import { CourseApplication } from '../../../../models/courseApplication';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-course-dashboard',
  imports: [CommonModule, FormsModule],
  templateUrl: './course-dashboard.component.html',
  styleUrl: './course-dashboard.component.css'
})
export class CourseDashboardComponent {
  applications: CourseApplication[] = [];
  showSpinner = true;
  selectedLevel: string = '';
  selectedStatus: string = '';

  constructor(
    private courseApplicationService: CourseApplicationService,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.loadAllApplications();
  }

  loadAllApplications(): void {
    this.courseApplicationService.getAllApplications().subscribe({
      next: (apps) => {
        console.log("Kursbewerbungen abgerufen");
        console.log(apps);
        this.applications = apps;
        this.showSpinner = false;
      },
      error: (err) => {
        console.error('Fehler beim Abrufen der Kursbewerbungen:', err);
        this.sharedService.handleError(err, 'error', 'Fehler beim Laden der Kursbewerbungen. Bitte versuchen Sie es erneut.');
        this.showSpinner = false;
        this.spinner.hide();
      }
    });
  }

  filterByLevel(): void {
    if (this.selectedLevel != "") {
      this.courseApplicationService.getApplicationsByLevel(this.selectedLevel).subscribe({
        next: (apps) => {
          this.applications = apps;
          this.showSpinner = false;
        },
        error: (err) => {
          console.error('Fehler beim Abrufen der Bewerbungen nach Niveau:', err);
          this.sharedService.handleError(err, 'error', 'Fehler beim Laden der Bewerbungen für das ausgewählte Niveau.');
          this.showSpinner = false;
        }
      });
    } else {
      this.loadAllApplications();
    }
  }

  filterByStatus(): void {
    this.spinner.show();
    if (this.selectedStatus) {
      this.courseApplicationService.getApplicationsByStatus(this.selectedStatus as 'pending' | 'accepted' | 'rejected').subscribe({
        next: (apps) => {
          this.applications = apps;
          this.showSpinner = false;
          this.spinner.hide();
        },
        error: (err) => {
          console.error('Fehler beim Abrufen der Bewerbungen nach Status:', err);
          this.sharedService.handleError(err, 'error', 'Fehler beim Laden der Bewerbungen für den ausgewählten Status.');
          this.showSpinner = false;
          this.spinner.hide();
        }
      });
    } else {
      this.loadAllApplications();
    }
  }
}